<template>
  <v-app>
    <Header/>
    <Sidebar/>
    <v-content>
      <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
        <v-layout>
          <v-flex text-xs-left xs12 md3 px-3>
            <v-text-field v-model="search" append-icon="search" placeholder="Search" v-if="!currentLoader" style="padding-bottom: 0 !important;"></v-text-field>
          </v-flex>
          <v-flex text-xs-right xs12 md9>
            <v-btn flat v-if="!currentLoader" @click="toggleFilterInactive(false)" class="bw-4" :style="buttonStyleFilterActive" :disabled="!filterInactive">Active</v-btn>
            <v-btn flat v-if="!currentLoader" @click="toggleFilterInactive(true)" class="bw-4" :style="buttonStyleFilterInactive" :disabled="filterInactive" style="margin-right: 50px;">Inactive</v-btn>
            <v-btn flat v-if="!currentLoader" v-on:click="editNewLoader" class="bw-6">Create new loader</v-btn>
            <v-btn flat v-if="currentLoader" :disabled="saveButtonDisabled" v-on:click="save" class="bw-3">{{ currentLoader.id > 0 ? 'Save' : 'Create' }}</v-btn>
            <v-btn flat v-if="canDelete" v-on:click="confirmDeleteDialog = true" class="bw-3">Delete</v-btn>
            <v-btn flat v-if="currentLoader" v-on:click="cancel" class="bw-3">Cancel</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-2 px-3 v-show="!currentLoader" >
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
            <v-data-table :headers="headers" :items="filteredLoaders" :search="search" hide-actions class="loaderList">
              <template v-slot:items="props">
                <tr @click="selectRow(props.item)" class="selectable">
                  <td class="text-xs-left">{{ props.item.name }}</td>
                  <td class="text-xs-left">{{ props.item.vat }}</td>
                  <td class="text-xs-left">{{ props.item.email }}</td>
                  <td class="text-xs-left">{{ props.item.phone }}</td>
                  <td class="text-xs-left">{{ props.item.mobile }}</td>
                  <td class="text-xs-left" style="white-space: nowrap;"><div v-html="suppliersToString(props.item.suppliers)"></div></td>
                  <td class="text-xs-left" style="white-space: nowrap;"><div v-html="pickupAddressesToString(props.item.pickupAddresses)"></div></td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container fluid py-2 px-3 v-if="currentLoader" >
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="overflow-y: auto;">
            <Panel>
              <PanelColumn title="Loader">
                <v-flex xs4 md2>
                  <v-label>Name</v-label>
                </v-flex>
                <v-flex xs8 md5>
                  <v-text-field color="teal" v-model="currentLoader.name" ref="name" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs0 md1/>
                <v-flex xs4 md2>
                </v-flex>
                <v-flex xs8 md2>
                </v-flex>

                <v-flex xs4 md2>
                  <v-label>E-mail</v-label>
                </v-flex>
                <v-flex xs8 md5>
                  <v-text-field color="teal" v-model="currentLoader.email" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs0 md1/>
                <v-flex xs4 md2>
                  <v-label>VAT no.</v-label>
                </v-flex>
                <v-flex xs8 md2>
                  <v-text-field color="teal" v-model="currentLoader.vat" style="width: 120px;" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 md2>
                  <v-label>Phone</v-label>
                </v-flex>
                <v-flex xs8 md5>
                  <v-text-field color="teal" v-model="currentLoader.phone" style="width: 120px;" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs0 md1/>
                <v-flex xs4 md2>
                  <v-label>Mobile</v-label>
                </v-flex>
                <v-flex xs8 md2>
                  <v-text-field color="teal" v-model="currentLoader.mobile" style="width: 120px;" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 md2>
                  <v-label>Inactive</v-label>
                </v-flex>
                <v-flex xs8 md10>
                  <v-checkbox color="teal" v-model="currentLoader.inactive"/>
                </v-flex>
                <v-flex xs12/>

                <v-flex xs4 md2 style="line-height: 35px;">
                  <v-label>Supplier</v-label>
                </v-flex>
                <v-flex xs8 md10>
                  <v-select
                    v-model="currentLoader.suppliers"
                    :items="suppliers"
                    :menu-props="{ maxHeight: '300' }"
                    item-text="name"
                    multiple
                    return-object
                  ></v-select>
                </v-flex>

                <v-flex xs4 md2 style="line-height: 35px;">
                  <v-label>Loading address</v-label>
                </v-flex>
                <v-flex xs8 md10>
                  <v-select
                    v-model="currentLoader.pickupAddresses"
                    :items="pickupAddresses"
                    :menu-props="{ maxHeight: '300' }"
                    item-text="text"
                    multiple
                    return-object
                  ></v-select>
                </v-flex>
              </PanelColumn>

              <v-flex xs12 px-5 py-3 text-xs-center>
              </v-flex>

              <PanelColumn2 title="Address">
                <v-flex xs4 sm4>
                  <v-label>Street</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentLoader.address.street" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>House no.</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentLoader.address.houseNo" style="width: 75px;" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>Location</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentLoader.address.location" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>Postal code</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentLoader.address.zipCode" style="width: 100px" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>City</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentLoader.address.city" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>Country</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentLoader.address.country" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>Geo code</v-label>
                </v-flex>
                <v-flex xs4 sm4 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentLoader.address.latitude" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs4 sm4 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentLoader.address.longitude" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs12 text-xs-right>
                  <v-btn @click="$refs.maps.addressToGeo(currentLoader.address)" flat>Lookup geo code</v-btn>
                </v-flex>
              </PanelColumn2>
              <v-flex xs12 class="hidden-md-and-up" style="height: 25px;"></v-flex>
              <PanelColumn2 style="padding-top: 25px;">
                <Maps v-model="currentLoader.address" ref="maps" height="285px"/>
              </PanelColumn2>
            </Panel>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <Footer/>

    <v-dialog v-model="confirmDeleteDialog" persistent width="350">
      <v-card pa-5>
        <v-card-title class="headline">Delete loader</v-card-title>
        <v-card-text v-if="currentLoader">Are you sure you want to delete '{{ currentLoader.name }}'?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.delete">Yes</v-btn>
          <v-btn flat @click="confirmDeleteDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import Panel from '../components/Panel'
import Maps from '../components/Maps'
import PanelColumn from '../components/PanelColumn'
import PanelColumn2 from '../components/PanelColumn2'
import axios from 'axios'

export default {
  name: 'Loaders',
  components: {Header, Sidebar, Footer, Panel, PanelColumn, PanelColumn2, Maps},
  data () {
    return {
      search: '',
      headers: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'VAT', value: 'vat', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Phone', value: 'phone', sortable: false },
        { text: 'Mobile', value: 'mobile', sortable: false },
        { text: 'Supplier', value: 'suppliers', sortable: false },
        { text: 'Loading address', value: 'pickupAddresses', sortable: false }
      ],
      loaders: [],
      currentLoader: null,
      confirmDeleteDialog: false,
      suppliers: [],
      pickupAddresses: [],
      filterInactive: false
    }
  },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', { key: 'loaders' })
    this.loadLoaders()
  },
  computed: {
    users: function () {
      return this.$store.state.user.users
    },
    saveButtonDisabled: function () {
      return !this.currentLoader || this.currentLoader.name.trim() === ''
    },
    canDelete: function () {
      return this.currentLoader && this.currentLoader.id > 0
    },
    buttonStyleFilterActive () {
      return (this.filterInactive === false ? ' color: #606060 !important;' : '')
    },
    buttonStyleFilterInactive () {
      return (this.filterInactive === true ? ' color: #606060 !important;' : '')
    },
    filteredLoaders () {
      return this.loaders.filter(c => this.filterInactive ? c.inactive : !c.inactive)
    }
  },
  methods: {
    loadLoaders () {
      // console.log('Loading loaders')
      axios.get('/backend/rest/loader/all')
        .then(response => {
          this.loaders = response.data
        })
    },
    loadSuppliers () {
      axios.get('/backend/rest/supplier/all')
        .then(response => {
          this.suppliers = response.data
        })
    },
    loadPickupAddresses () {
      axios.get('/backend/rest/pickup_address')
        .then(response => {
          this.pickupAddresses = response.data
        })
    },
    selectRow (item) {
      for (let c of this.loaders) {
        if (c.id === item.id) {
          this.currentLoader = c
          if (this.currentLoader.address.latitude === 0) {
            this.currentLoader.address.latitude = ''
          }
          if (this.currentLoader.address.longitude === 0) {
            this.currentLoader.address.longitude = ''
          }
          break
        }
      }
      this.loadSuppliers()
      this.loadPickupAddresses()
      // console.log('The current loader is: ' + this.currentLoader.name)
    },
    editNewLoader () {
      // console.log('Create a new loader')
      this.currentLoader = {
        id: 0,
        name: '',
        vat: '',
        email: '',
        phone: '',
        mobile: '',
        address: {
          street: '',
          houseNo: '',
          location: '',
          zipCode: '',
          city: '',
          country: '',
          latitude: '',
          longitude: ''
        }
      }
      this.loadSuppliers()
      this.loadPickupAddresses()
      this.$nextTick(() => this.$refs.name.focus())
    },
    save () {
      // console.log('Save the loader')
      axios.post('/backend/rest/loader', this.currentLoader)
        .then(response => {
          // console.log('Got response: ' + response)
          this.loadLoaders()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.currentLoader = null
    },
    delete () {
      // console.log('Delete loader: ' + this.currentLoader.name)

      axios.delete('/backend/rest/loader/' + this.currentLoader.id)
        .then(response => {
          // console.log('Got response: ' + response)

          this.loadLoaders()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })

      this.confirmDeleteDialog = false
      this.currentLoader = null
    },
    cancel () {
      // console.log('Cancel the loader')
      this.currentLoader = null
      this.loadLoaders()
    },
    suppliersToString (suppliers) {
      if (suppliers && suppliers.length > 0) {
        let s = ''
        for (let su of suppliers) {
          if (s !== '') {
            s += '<br/>'
          }
          s += su.name
        }
        return s
      }
      return ''
    },
    pickupAddressesToString (pickupAddresses) {
      if (pickupAddresses && pickupAddresses.length > 0) {
        let s = ''
        for (let pa of pickupAddresses) {
          if (s !== '') {
            s += '<br/>'
          }
          s += pa.text
        }
        return s
      }
      return ''
    },
    toggleFilterInactive (inactive) {
      this.filterInactive = inactive
    }
  }
}
</script>
<style scoped>
  html {
    overflow-y: auto;
  }
  .v-input {
    padding-top: 0;
    margin-top: 0;
  }
  .loaderList tr td {
    vertical-align: top;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Loaders.vue